import { render, staticRenderFns } from "./house-require-read.vue?vue&type=template&id=1df337ac"
import script from "./house-require-read.vue?vue&type=script&lang=ts"
export * from "./house-require-read.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports